import React from "react"
import ListAge from "./ListAge"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

export default function AgeSettings() {
  return (
    <div>
      <CustomBreadCrumb activeText='Age settings' data={ [{ url: '/settings', title: 'Settings' }] } />
      <ListAge />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/AgeSettings.js